export default __webpack_public_path__ + "static/media/tab-content-image-02.9f6ac326.jpg";